// use :focus:not(:focus-visible) { outline: none } on whole document
export const focusMixin = `
  &:focus-visible {
    outline: 1px solid rgb(0, 162, 255);
    outline-offset: 2px;
  }
`;
